import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

export function trim(): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const value: any = control.value;

    if (!value) {
      return null;
    }

    if (typeof value !== 'string') { return { invalid: true }; }

    const trimmed = value.trim();
    const noWhitespace = trimmed.replace(/\s+/g, '');

    if (noWhitespace === '' || /^0+$/.test(noWhitespace) || noWhitespace.toLowerCase() === 'null') {
      return { required: true };
    }

    return null;
  };
}
